
import React, { useState } from "react";
import OverlayContainerWithMaterialUi from "./OverlayContainerWithMaterialUi";
import { handleCancelSubscription } from "../../utils/zohoHelper";
const PURCHASE_TYPE = {
  RUN_WITH_PREVIOUS_PLAN: "runWithPreviousPlan",
  DISCOUNTINUE_PREVIOUS_PLAN: "discontinuePreviousPlan",
};

const Radio = ({ id, name, value, onChange, label }) => {
  return (
    <div>
      <input
        type="radio"
        name={name}
        id={id}
        value={value}
        className="zoho-custom-checkbox"
        onChange={onChange}
      />
      <label htmlFor="r1" className="checkbox-label-zoho-cancel-current">
        {label}
      </label>
    </div>
  );
};
const TableComponent = ({ relatedPlan, cancelPlanIds, setCancelPlanIds }) => {
  //   const [cancelPlanIds, setCancelPlanIds] = useState([]);
  console.log(relatedPlan, "relatedPlan");
  const handleCheckboxChange = (subscriptionId, isChecked) => {
    setCancelPlanIds((prev) =>
      isChecked
        ? [...prev, subscriptionId]
        : prev.filter((id) => id !== subscriptionId)
    );
  };

  return (
    <div className="zoho-checkout-org-table-container">
      <table className="custom-table">
        <thead>
          <tr>
            <th>Plan Name</th>
            <th>Subscription Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {relatedPlan?.map((item) => (
            <tr key={item?.subscriptionId}>
              <td>{item?.planName}</td>
              <td>
                {item?.currencySymbol}
                {item?.amount}
              </td>
              <td>
                <input
                  type="checkbox"
                  onChange={(e) =>
                    handleCheckboxChange(item?.subscriptionId, e.target.checked)
                  }
                  className="zoho-custom-checkbox"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
const OrganisationCancelCurrentSubscriptionWarn = ({
  open,
  onClose,
  planCode,
  selectedPlans,
  relatedPlan,
}) => {
  const [purchaseType, setPurchaseType] = useState(
    PURCHASE_TYPE.RUN_WITH_PREVIOUS_PLAN
  );
  const [cancelPlanIds, setCancelPlanIds] = useState([]);

  // console.log(selectedPlans, relatedPlan, 'selectedPlans');

  const helperCancelSubscription = async () => {
    try {
      if (cancelPlanIds?.length > 0) {
        const data = await handleCancelSubscription(cancelPlanIds, () => {
          onClose();
        });
        console.log(data, "data cancelled");
      } else {
        onClose();
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  return (
    <>
      <OverlayContainerWithMaterialUi open={true}>
        <div className="cancel-subscription-warn-container">
          <div className="cancel-subscription-warn-header">
            <h2 className="">Purchasing {selectedPlans?.name}</h2>
            {/* <button onClick={onClose}>
              <CrossIcon />
            </button> */}
          </div>
          <div className="flex flex-col gap-[10px]">
            <div className="flex items-center gap-2">
              <Radio
                id={PURCHASE_TYPE.RUN_WITH_PREVIOUS_PLAN}
                name={"planType"}
                value={PURCHASE_TYPE.RUN_WITH_PREVIOUS_PLAN}
                onChange={(e) => {
                  setCancelPlanIds([]);
                  console.log(e.target.value, "eTargetValue");
                  setPurchaseType(e.target.value);
                }}
                label="Run with previous plan simultaneously"
              />
            </div>
            <div className="flex items-center gap-2">
              <Radio
                id={PURCHASE_TYPE.DISCOUNTINUE_PREVIOUS_PLAN}
                name={"planType"}
                value={PURCHASE_TYPE.DISCOUNTINUE_PREVIOUS_PLAN}
                onChange={(e) => {
                  setPurchaseType(e.target.value);
                  console.log(e.target.value, "eTargetValue");
                }}
                label="Discontinue the previous plan and proceed with this one."
              />
            </div>
          </div>
          {purchaseType === PURCHASE_TYPE.DISCOUNTINUE_PREVIOUS_PLAN && (
            <TableComponent
              relatedPlan={relatedPlan}
              cancelPlanIds={cancelPlanIds}
              setCancelPlanIds={setCancelPlanIds}
            />
          )}

          <div className="cancel-subscription-warn-actions">
            <button
              className="primaryButton "
              onClick={helperCancelSubscription}
            >
              {"Continue"}
            </button>
          </div>
        </div>
      </OverlayContainerWithMaterialUi>
    </>
  );
};

export default OrganisationCancelCurrentSubscriptionWarn;
